module.exports = __webpack_public_path__ + "d2fff7369e780bf4c748a3276c2b777d.svg";